var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, useRef, useState, useCallback } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useSessionState, useAuthorization } from '@store/session';
import { useResetPassword } from '@store/session/service';
import { classNames, encryptToBase64 } from '@src/utils';
import { useLocation } from 'react-router-dom';
var prefixCls = 'password-form';
function PasswordForm(props) {
    var location = useLocation();
    var formRef = useRef(null);
    var _a = useSessionState(), uid = _a.uid, xuexinID = _a.xuexinID;
    var token = useAuthorization();
    var _b = useState({ password: '' }), state = _b[0], setState = _b[1];
    var className = useMemo(function () {
        return classNames(prefixCls, props.className);
    }, [props.className]);
    // 重置密码参数
    var resetParams = useState({
        token: token,
        uid: uid,
        xuexinID: xuexinID,
        password: '',
    })[0];
    var _c = useResetPassword(), resetPasswordFn = _c.mutateAsync, isLoading = _c.isLoading;
    // 重置密码
    var handleOnFinish = useCallback(function () {
        if (formRef.current === null)
            return void 0;
        var password = encryptToBase64(state.password, xuexinID);
        resetPasswordFn(__assign(__assign({}, resetParams), { password: password }))
            .then(function () {
            if (Boolean(location.search) === true) {
                var url = location.search.split('url=')[1];
                window.location.href = "" + url;
            }
            else {
                window.location.href = location.pathname + "/login";
            }
        })
            .catch(function (error) {
            message.error(error);
        });
    }, [state, xuexinID, resetPasswordFn, resetParams, location]);
    var handleOnValuesChange = useCallback(function (_value, values) {
        if (formRef.current === null)
            return void 0;
        setState(values);
    }, [setState]);
    return (React.createElement(Form, { ref: formRef, className: className, scrollToFirstError: true, initialValues: state, onFinish: handleOnFinish, onValuesChange: handleOnValuesChange },
        React.createElement(Form.Item, { name: "password", dependencies: ['confirmPassword'], validateTrigger: ['onChange', 'onBlur'], rules: [
                { required: true, whitespace: true, message: '密码不能为空' },
                {
                    pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=\S+$).{6,20}$/,
                    message: '密码为6-20位数字和字母组合',
                },
            ] },
            React.createElement(Input.Password, { placeholder: "\u5BC6\u7801\u4E3A6-20\u4F4D\u6570\u5B57\u548C\u5B57\u6BCD\u7EC4\u5408", size: "large" })),
        React.createElement(Form.Item, { name: "confirmPassword", dependencies: ['password'], validateTrigger: ['onChange', 'onBlur'], rules: [
                { required: true, message: '请确认密码' },
                {
                    validator: function (rule, value, callback) {
                        // 写了新密码，并且和确认密码不相同
                        if (state.password &&
                            state.confirmPassword &&
                            "" + state.password !== "" + state.confirmPassword) {
                            return callback('两次输入的密码不相同');
                        }
                        else {
                            callback();
                        }
                    },
                },
            ] },
            React.createElement(Input.Password, { placeholder: "\u8BF7\u786E\u8BA4\u5BC6\u7801", size: "large" })),
        React.createElement(Form.Item, null,
            React.createElement(Button, { block: true, type: "primary", htmlType: "submit", size: "large", loading: isLoading }, "\u786E\u5B9A"))));
}
export default React.memo(PasswordForm);
